/* The preview nav.

   One panel open at a time. Hover opens it on a pointer device after a short
   delay, so crossing the bar on the way somewhere else does not fire every
   panel in turn; a click opens it outright, which is also the touch path.
   Escape, a click outside, or moving off the whole nav closes it. */
(function () {
  var nav = document.querySelector('[data-ejh-nav]');
  if (!nav) { return; }

  var words = nav.querySelectorAll('[data-ejn-word]');
  var scrim = nav.querySelector('[data-ejn-scrim]');
  var burger = nav.querySelector('[data-ejn-burger]');
  var openTimer = null;
  var closeTimer = null;
  var current = null;

  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  /* The panels are a desktop idea. Below the breakpoint where the burger
     appears the words are a table of contents instead, so the same query
     decides both what is shown and what a tap does. */
  var narrow = window.matchMedia('(max-width: 989px)');

  /* The words that have a section of their own on the homepage. */
  var HOME_IDS = ['for-him', 'for-her', 'for-them', 'essentials', 'performance'];

  function panelFor(word) {
    return document.getElementById(word.getAttribute('aria-controls'));
  }

  /* ------------------------------------------------------------------
     The shelf drifts.

     Rudi: "if the products get hidden because the list is too long make it
     auto scroll to the left slowly until mouse over, if mouse off continue
     scrolling."

     For Him has fourteen products and the strip shows six, so the rest
     would simply never be seen. The shelf creeps sideways at 24px a second
     -- slow enough to read, fast enough to notice -- holds at each end for
     a beat, and comes back. It runs only when something is actually
     hidden, pauses the moment the pointer is over it, and resumes from
     where it stopped when the pointer leaves, so a hover is never a fight.

     The position is kept as a float of our own: scrollLeft rounds, and at
     this speed a frame's worth of movement rounds to zero, which would
     stall the whole thing.
     ------------------------------------------------------------------ */
  var DRIFT_SPEED = 24;
  var DRIFT_HOLD = 1400;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var drift = { shelf: null, pos: 0, dir: 1, hold: 0, last: 0, raf: null, over: false };

  function driftStop() {
    if (drift.raf) { window.cancelAnimationFrame(drift.raf); }
    drift.raf = null;
    drift.shelf = null;
  }

  function driftStep(now) {
    var shelf = drift.shelf;
    if (!shelf) { return; }
    drift.raf = window.requestAnimationFrame(driftStep);

    var dt = drift.last ? Math.min(64, now - drift.last) : 0;
    drift.last = now;
    if (drift.over || !dt) { return; }

    var max = shelf.scrollWidth - shelf.clientWidth;
    if (max <= 1) { return; }

    /* Follow the element if something else moved it -- a wheel, a drag. */
    if (Math.abs(shelf.scrollLeft - drift.pos) > 2) { drift.pos = shelf.scrollLeft; }

    if (drift.hold > 0) { drift.hold -= dt; return; }

    drift.pos += drift.dir * DRIFT_SPEED * dt / 1000;
    if (drift.pos >= max) { drift.pos = max; drift.dir = -1; drift.hold = DRIFT_HOLD; }
    else if (drift.pos <= 0) { drift.pos = 0; drift.dir = 1; drift.hold = DRIFT_HOLD; }
    shelf.scrollLeft = drift.pos;
  }

  function driftStart(panel) {
    driftStop();
    if (reduced.matches || !finePointer.matches || !panel) { return; }
    var shelf = panel.querySelector('.ejn__shelf');
    if (!shelf) { return; }
    /* Nothing hidden means nothing to do. */
    if (shelf.scrollWidth - shelf.clientWidth <= 1) { return; }
    shelf.scrollLeft = 0;
    drift.shelf = shelf;
    drift.pos = 0;
    drift.dir = 1;
    drift.hold = DRIFT_HOLD;
    drift.last = 0;
    drift.over = false;
    drift.raf = window.requestAnimationFrame(driftStep);
  }

  Array.prototype.forEach.call(nav.querySelectorAll('.ejn__shelf'), function (shelf) {
    shelf.addEventListener('mouseenter', function () { drift.over = true; });
    shelf.addEventListener('mouseleave', function () { drift.over = false; });
  });

  function close() {
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    closeTimer = null;
    if (!current) { return; }
    var panel = panelFor(current);
    current.setAttribute('aria-expanded', 'false');
    if (panel) { panel.classList.remove('is-instant'); panel.classList.remove('is-open'); }
    driftStop();
    nav.classList.remove('is-open');
    if (scrim) { scrim.classList.remove('is-on'); }
    window.setTimeout(function () {
      if (scrim && !scrim.classList.contains('is-on')) { scrim.hidden = true; }
    }, 440);
    current = null;
  }

  /* The sheet slides down on the way in and back up on the way out. Moving
     from one word to the next while it is already down must not do either:
     two sheets passing each other is the "background keeps disappearing"
     Rudi called out. So a swap is marked instant on both panels, held for a
     frame so the browser paints the new state without a transition, then
     unmarked -- which leaves the closing slide intact for later. */
  function open(word) {
    window.clearTimeout(closeTimer);
    closeTimer = null;
    if (current === word) { return; }

    var swapping = !!current;
    var prev = null;
    if (current) {
      prev = panelFor(current);
      current.setAttribute('aria-expanded', 'false');
    }
    var panel = panelFor(word);
    if (!panel) { return; }

    if (swapping) {
      if (prev) { prev.classList.add('is-instant'); }
      panel.classList.add('is-instant');
    }
    if (prev) { prev.classList.remove('is-open'); }
    if (scrim) { scrim.hidden = false; }

    window.requestAnimationFrame(function () {
      panel.classList.add('is-open');
      nav.classList.add('is-open');
      if (scrim) { scrim.classList.add('is-on'); }
      /* The shelf has to be laid out before its overflow can be measured,
         which the class above has just caused. */
      driftStart(panel);
      if (!swapping) { return; }
      window.requestAnimationFrame(function () {
        if (prev) { prev.classList.remove('is-instant'); }
        panel.classList.remove('is-instant');
      });
    });
    word.setAttribute('aria-expanded', 'true');
    current = word;
  }


  /* The section a word names, if the page carries one. The openers take
     their id from their eyebrow, so "For him" finds #for-him. */
  /* Land the section's banner exactly under the bar. Rudi asked for the
     browser to go fullscreen at the same time and then changed his mind, so
     that is gone; the second measurement stays, because the drawer closing
     and the sticky bar settling both move the page under a smooth scroll. */
  function goToSection(target) {
    close();
    nav.classList.remove('is-menu');
    if (burger) { burger.setAttribute('aria-expanded', 'false'); }

    var tries = 0;
    function land() {
      var bar = nav.querySelector('.ejn__bar');
      var offset = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
      var box = target.getBoundingClientRect();
      if (target.classList.contains('ejh-pairbanner')) {
        offset += Math.max(0, Math.round(box.left));
      }
      var top = box.top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: tries ? 'auto' : 'smooth' });
      tries += 1;
    }
    land();
    window.setTimeout(land, 420);
  }

  function idFor(word) {
    return (word.textContent || '').trim().toLowerCase().replace(/\s+/g, '-');
  }

  function sectionFor(word) { return sectionForId(idFor(word)); }

  function sectionForId(id) {
    if (!id) { return null; }
    var el = document.getElementById(id);
    /* Rudi: "when I click For her on the mobile menu it doesn't go to that
       section." In the ask layout the banner for the gender the visitor did
       NOT pick is hidden (ejh-opener--dupe), so its box measures nothing and
       the scroll landed at the top of the page. A hidden banner is skipped
       and the gender's own group of tiles is the target instead. */
    if (el && el.getClientRects().length === 0) { el = null; }
    if (!el && id.indexOf('for-') === 0) {
      el = document.querySelector('[data-vb-group="' + id.slice(4) + '"]');
    }
    return el;
  }

  function headerOffset() {
    var bar = nav.querySelector('.ejn__bar');
    return bar ? Math.round(bar.getBoundingClientRect().height) + 6 : 0;
  }

  Array.prototype.forEach.call(words, function (word) {
    word.addEventListener('click', function (e) {
      e.preventDefault();
      if (narrow.matches) {
        var target = sectionFor(word);
        if (target) { goToSection(target); return; }
        /* Rudi, 2026-09-23: "for the mobile menu, make sure when they click
           on For Him etc it goes to the correct section on the homepage."
           On an inner page there is no such section, so go to the homepage
           and land on it there (see the hash handler at the end). */
        var wid = idFor(word);
        if (HOME_IDS.indexOf(wid) !== -1 && location.pathname !== '/') {
          window.location.href = '/#' + wid;
          return;
        }
        /* No section on the page for this word: follow its collection. */
        var panel = panelFor(word);
        var fallback = panel && panel.querySelector('.ejn__all');
        if (fallback) { window.location.href = fallback.getAttribute('href'); return; }
      }
      if (current === word) { close(); } else { open(word); }
    });
    word.addEventListener('mouseenter', function () {
      if (!finePointer.matches) { return; }
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      if (current) { open(word); return; }
      openTimer = window.setTimeout(function () { open(word); }, 110);
    });
    word.addEventListener('mouseleave', function () {
      window.clearTimeout(openTimer);
    });
    word.addEventListener('focus', function () { open(word); });
  });

  var CLOSE_DELAY = 220;

  /* Over a word, or over the panel's CONTENT, counts as staying. Not the
     panel's empty space: the panel is the full-viewport overlay now, so
     counting all of it would mean the menu never closed. Rudi asked for it
     to stay "until they move off a specific menu item or product", which is
     exactly the inner column. */
  function onTarget(node) {
    if (!node || !node.closest) { return false; }
    if (node.closest('[data-ejn-word]')) { return true; }
    var panel = current && panelFor(current);
    if (!panel) { return false; }
    var inner = node.closest('.ejn__panelinner');
    return !!(inner && panel.contains(inner));
  }

  document.addEventListener('mousemove', function (e) {
    if (!finePointer.matches || !current) { return; }
    if (onTarget(e.target)) { window.clearTimeout(closeTimer); return; }
    if (closeTimer) { return; }
    closeTimer = window.setTimeout(function () { closeTimer = null; close(); }, CLOSE_DELAY);
  }, { passive: true });

  nav.addEventListener('mouseleave', function () {
    if (!finePointer.matches) { return; }
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () { closeTimer = null; close(); }, CLOSE_DELAY);
  });

  if (scrim) { scrim.addEventListener('click', close); }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); }
  });

  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target)) { close(); return; }
    /* A click on the dim itself, outside the inner column, closes too. */
    if (e.target.classList && e.target.classList.contains('ejn__panel')) { close(); }
  });

  /* The phone layout hides the word list behind the burger. */
  var drawerTimer = null;

  function closeDrawer() {
    window.clearTimeout(drawerTimer);
    drawerTimer = null;
    nav.classList.remove('is-menu');
    if (burger) { burger.setAttribute('aria-expanded', 'false'); }
    close();
  }

  var DRAWER_ROLL = 2000;

  function armDrawer(afterOpen) {
    window.clearTimeout(drawerTimer);
    if (!nav.classList.contains('is-menu')) { return; }
    drawerTimer = window.setTimeout(closeDrawer, afterOpen ? DRAWER_ROLL + 5000 : 5000);
  }

  if (burger) {
    burger.addEventListener('click', function () {
      var on = nav.classList.toggle('is-menu');
      burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { armDrawer(true); } else { closeDrawer(); }
    });

    ['touchstart', 'pointerdown', 'mousemove', 'keydown', 'scroll'].forEach(function (evt) {
      nav.addEventListener(evt, function () { armDrawer(false); }, { passive: true });
    });
  }

  /* Arriving on the homepage from an inner page's menu, as /#for-her.
     The browser's own jump can land on a banner the layout then hides or
     moves (the ask layout rearranges the page for the visitor's pick), so
     the landing is done here once the page has settled, the same way a tap
     on the homepage's own menu does it. */
  (function landFromHash() {
    if (location.pathname !== '/') { return; }
    /* layout/theme.liquid takes the hash off the URL before anything paints
       (to stop the browser's own jump) and parks it in window.__deferredHash,
       so location.hash is already empty by the time this runs. */
    var id = (window.__deferredHash || location.hash || '').replace(/^#/, '').toLowerCase();
    if (HOME_IDS.indexOf(id) === -1) { return; }
    /* The homepage rearranges itself for the visitor's pick after the first
       paint: the banner for the gender they did not choose is hidden and its
       tiles move into a group further down. A single scroll made before that
       happened was left pointing at the top of the page (the test caught it
       for exactly that case: "For her" from an inner page after picking him).
       So the landing is re-checked for a few seconds and corrected until the
       section sits under the bar, and it stops the moment the visitor
       scrolls or touches the page themselves. */
    var stopped = false;
    function stop() { stopped = true; }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (evt) {
      window.addEventListener(evt, stop, { passive: true, once: true });
    });
    function barHeight() {
      var bar = nav.querySelector('.ejn__bar');
      return bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    }
    function go() {
      if (stopped) { return; }
      var target = sectionForId(id);
      if (!target) { return; }
      var top = target.getBoundingClientRect().top;
      var want = barHeight();
      if (target.classList.contains('ejh-pairbanner')) { return goToSection(target); }
      if (Math.abs(top - want) > 12) {
        window.scrollTo({ top: Math.max(0, Math.round(top + window.pageYOffset - want)), behavior: 'auto' });
      }
    }
    if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }
    [300, 700, 1200, 1900, 2800, 4000].forEach(function (ms) { window.setTimeout(go, ms); });
    window.addEventListener('load', function () { window.setTimeout(go, 150); window.setTimeout(go, 900); });
  })();
}());
